'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _GooglePlaces = require('./GooglePlaces');

var _GooglePlaces2 = _interopRequireDefault(_GooglePlaces);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _GooglePlaces2.default;


//////////////////
// WEBPACK FOOTER
// ./~/@synapsestudios/google-places-field/lib/index.js
// module id = 740
// module chunks = 0